module.exports = __webpack_public_path__ + "img/perfil-generico-01.0bfcd940.png";